function ReactProductCard(props) {
  let product = props.item ? props.item : props.hit;
  const [drawerHeight, setDrawerHeight] = React.useState("0");
  const [drawerBackVis, setDrawerBackVis] = React.useState("hidden");
  const [opacity, setOpacity] = React.useState(0);
  const [loaded, setLoaded] = React.useState(false);
  const [timer, setTimer] = React.useState("");
  const [badge, setBadge] = React.useState("");
  const [badge2, setBadge2] = React.useState("");
  const [productObj, setProductObj] = React.useState(product);
  const [productImages, setProductImages] = React.useState([]);
  const [productVariants, setProductVariants] = React.useState([]);
  const [isWishlistItem, setIsWishlistItem] = React.useState(false);
  const [swymLoaded, setSwymLoaded] = React.useState(false);
  const [colorVariant, setColorVariant] = React.useState();
  const [swatches, setSwatches] = React.useState([]);
  const inputRef = React.useRef(null);
  const onMouse = React.useCallback(() => openQuickBuy(), []);
  const onMouseLeave = React.useCallback(() => closeQuickBuy(), []);
  const endpoint = 'https://tlfapparel.myshopify.com/api/2023-01/graphql.json';
  const headers = new Headers({
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'X-Shopify-Storefront-Access-Token': '239f5284842448954ceaeb9e81a967b4'
  });
  React.useEffect(() => {
    if (colorVariant) {
      setLoaded(false);
      setProductObj(colorVariant?.data?.productByHandle);
      setProductImages(colorVariant?.data?.productByHandle?.images?.edges);
      setProductVariants(colorVariant?.data?.productByHandle?.variants?.edges);
      setLoaded(true);
    }
  }, [colorVariant]);
  const fetchImagesAndVariants = async () => {
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({
        query: query()
      })
    });
    const shopifyProduct = await response.json();
    shopifyProduct.data.node.limited_time_offer && setTimer(shopifyProduct.data.node.limited_time_offer.value);
    setProductImages(shopifyProduct.data.node.images.edges);
    setProductVariants(shopifyProduct.data.node.variants.edges);
    setLoaded(true);
    // product.backImage ? setHoverProductImage(product.backImage) : setHoverProductImage(shopifyProduct.data.node.media.edges[1].node.image.url) 

    // setSwatches(JSON.parse(shopifyProduct?.data?.node?.metafields[0]?.value).sort((a, b) => {
    //   if(shopifyProduct?.data?.node?.handle === a) {
    //     return -1;
    //   }

    //   if(shopifyProduct?.data?.node?.handle === b) {
    //     return 1;
    //   }

    //   return 0;
    // }));

    const productResponse = await fetch(endpoint, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({
        query: productQuery(product.handle)
      })
    });
    let productObject = await productResponse.json();
    productObject = productObject.data.product;
    ['SwymViewProducts', 'SwymWatchProducts', 'SwymProductVariants'].forEach(function (k) {
      if (!window[k]) window[k] = {};
    });
    let collections = productObject.productType;
    let o = {},
      empi = productObject.id.split("Product/")[1].toString(),
      piu = productObject.featuredImage;
    let currentVariant = productObject.variants.nodes[0];
    for (variant in productObject.variants.nodes) {
      if (productObject.variants.nodes[variant].selectedOptions[0].name === 'Bundle') {
        continue;
      }
      window.SwymProductVariants[productObject.variants.nodes[variant].id.split("ProductVariant/")[1].toString()] = {
        empi: empi,
        epi: productObject.variants.nodes[variant].id.split("ProductVariant/")[1].toString(),
        du: productObject.onlineStoreUrl,
        dt: productObject.title,
        ct: collections,
        iu: productObject.variants.nodes[variant].image ? productObject.variants.nodes[variant].image : piu,
        stk: productObject.variants.nodes[variant].quantityAvailable,
        pr: productObject.variants.nodes[variant].price.amount,
        variants: [{
          [productObject.variants.nodes[variant].title]: productObject.variants.nodes[variant].id.split("ProductVariant/")[1].toString()
        }]
      };
      window.SwymWatchProducts[productObject.variants.nodes[variant].id.split("ProductVariant/")[1].toString()] = o[productObject.variants.nodes[variant].id.split("ProductVariant/")[1].toString()] = {
        "id": productObject.variants.nodes[variant].id.split("ProductVariant/")[1].toString(),
        "available": productObject.variants.nodes[variant].availableForSale,
        "inventory_management": '',
        "inventory_quantity": productObject.variants.nodes[variant].quantityAvailable,
        "title": productObject.variants.nodes[variant].title,
        "inventory_policy": ''
      };
    }
    let product_data = {
      empi: empi,
      epi: currentVariant.id.split("ProductVariant/")[1].toString(),
      dt: productObject.title,
      du: productObject.onlineStoreUrl,
      ct: collections,
      pr: currentVariant.price.amount,
      stk: currentVariant.quantityAvailable,
      iu: currentVariant.image ? currentVariant.image.url : piu,
      variants: [{
        [currentVariant.title]: currentVariant.id
      }]
    };
    window.SwymViewProducts[productObject.handle] = SwymViewProducts[productObject.id.split("Product/")[1].toString()] = product_data;
    window.SwymWatchProducts[productObject.handle] = SwymWatchProducts[productObject.id.split("Product/")[1].toString()] = o;
  };
  const query = () => `{
    
    node(id: "gid:\/\/shopify\/Product\/${product.id}") {
      id
      ... on Product {
        metafields(identifiers: {namespace: "Products", key: "swatch_string"}) {
          value
          key
          namespace
        }
        images(first: 3) {
          edges {
            node {
              altText
              transformedSrc(maxWidth: ${props.windowWidth < 450 ? 367 : 1183}, maxHeight: ${props.windowWidth < 450 ? 550 : 1774})
            }
          }
        }
        limited_time_offer: metafield(namespace: "custom", key: "limited_time_offer") {
          value
        }
        handle
        variants(first: 9) {
          edges {
            node {
              id
              quantityAvailable
              selectedOptions{
                value
              }
            }
          }
        }
      }
    }
  }`;

  /**
   * 
   * graphQL query on Product object for: productByHandle(handle: string)
   *  - productType
   *  - id
   *  - title
   *  - handle
   *  - onlineStoreUrl
   *  - featuredImage (620x620)
   *  - variants
   * 
   * 
   *  - shop url
   */

  const colorVariantByHandle = handle => `{
    productByHandle(handle: "${handle}") {
      id
      images(first: 3) {
        edges {
          node {
            altText
            transformedSrc(maxWidth: ${props.windowWidth < 450 ? 367 : 1183}, maxHeight: ${props.windowWidth < 450 ? 550 : 1774})
          }
        }
      }
      tags
      title
      handle
      limited_time_offer: metafield(namespace: "custom", key: "limited_time_offer") {
        value
      }
      variants(first: 9) {
        edges {
          node {
            id
            selectedOptions {
              value
            }
            quantityAvailable
            price {
              amount
            }
            compareAtPrice {
              amount
            }
          }
        }
      }
    }
  }`;
  const productQuery = handle => `{
      product(handle: "${handle}") {
        id
        handle
        title
        onlineStoreUrl
        featuredImage {
          url(transform: {maxHeight: 620, maxWidth: 620})
          altText
          height
          id
          width
        }
        productType
        variants(first: 100) {
          nodes {
            id
            image {
              url(transform: {maxHeight: 620, maxWidth: 620})
              altText
              height
              id
              width
            }
            price {
              amount
            }
            quantityAvailable
            selectedOptions {
              name
              value
            }
            compareAtPrice {
              amount
            }
            title
            availableForSale
          }
        }
      }
  }`;
  function openQuickBuy() {
    setDrawerHeight("26%");
    setDrawerBackVis("visible");
    setOpacity(1);
  }
  function closeQuickBuy() {
    setDrawerHeight("0");
    setDrawerBackVis("hidden");
    setOpacity(0);
  }
  function drawerSwitch(e) {
    e.preventDefault();
    drawerHeight == "40%" ? setDrawerHeight("0") : setDrawerHeight("40%");
    drawerBackVis == "hidden" ? setDrawerBackVis("visible") : setDrawerBackVis("hidden");
    opacity == 0 ? setOpacity(1) : setOpacity(0);
  }
  function addToWishList(productId) {
    let swymObject = SwymViewProducts[productId];
    _swat.addToWishlistUsingDu(swymObject);
    setIsWishlistItem(true);
  }
  function addToCart(id) {
    if (product.__queryID) {
      try {
        aa('getUserToken', null, (err, userToken) => {
          if (err) {
            console.error(err);
            return;
          }
          // window.aa('viewedObjectIDs', {
          //   'eventType': 'view',
          //   'eventName': 'Test View Event',
          //   'index': 'TestIndex',
          //   'objectIDs': ['test-object']
          // })
          aa('convertedObjectIDsAfterSearch', {
            userToken: userToken,
            index: INDEX_NAME,
            eventName: "convertedObjectIDsAfterSearch",
            queryID: product.__queryID,
            objectIDs: [product.objectID]
          });
        });
      } catch (e) {
        console.log(e);
      }
    }
    let formData = {
      'items': []
    };
    formData.items.push({
      id: id,
      quantity: 1
    });
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    }).then(response => response.json()).then(data => {
      // document.querySelector('.js-drawer-open-cart').click();
      formData.items = [];

      // let newCart = new theme.CartDrawer();
      // newCart.buildCart(data, true, 'CartDrawer');
    }).catch(error => {
      console.error('Error:', error);
    });
  }
  function sendAlgoliaEvent() {
    try {
      sessionStorage.setItem("queryID", product.__queryID);
      sessionStorage.setItem("objectIDs", [product.objectID]);
      //sessionStorage.setItem("userToken", [product.__position]);
      aa('init', {
        appId: "35RQENUZNB",
        apiKey: "b7c2503191bc928ac947acc0b5815029",
        useCookie: true
      });
      aa('getUserToken', null, (err, userToken) => {
        if (err) {
          console.error(err);
          return;
        }
        // window.aa('viewedObjectIDs', {
        //   'eventType': 'view',
        //   'eventName': 'Test View Event',
        //   'index': 'TestIndex',
        //   'objectIDs': ['test-object']
        // })
        aa('clickedObjectIDsAfterSearch', {
          userToken: userToken,
          index: INDEX_NAME,
          eventName: "clickedObjectIDsAfterSearch",
          queryID: product.__queryID,
          objectIDs: [product.objectID],
          positions: [product.__position]
        });
      });
    } catch (e) {
      console.log(e);
    }
  }
  function getWishlistItems() {
    _swat.fetchWrtEventTypeET(products => {
      for (var i = 0; i < products.length; i++) {
        if (products[i].empi.toString() === product.id.toString()) {
          setIsWishlistItem(true);
        }
      }
    }, 4);
  }
  const observeSwat = function () {
    let targetNode = document.querySelector('body');
    const config = {
      attributes: true,
      childList: true,
      subtree: true
    };
    const callback = async (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === "childList") {
          if (mutation.target.id === 'swym-plugin') {
            await observeWishlist();
            getWishlistItems();
            setSwymLoaded(true);
            observer.disconnect();
          }
        }
      }
    };
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  };
  const observeWishlist = async function () {
    _swat.evtLayer.addEventListener('sw:removedfromwishlist', async event => {
      let productId = event.detail.d.empi;
      if (productId) {
        _swat.fetchLists({
          callbackFn: lists => {
            for (var i = 0; i < lists.length; i++) {
              let listId = lists[i].lid;
              if (lists[i].listcontents.length > 0) {
                _swat.deleteFromList(listId, {
                  epi: event.detail.d.epi,
                  empi: event.detail.d.empi,
                  du: event.detail.d.du
                }, success => {
                  // console.log('success: ', success);
                }, error => {
                  // console.log('error: ', error);
                });
              }
            }
            setIsWishlistItem(false);
            getWishlistItems();
          },
          errorFn: error => {
            console.log(error);
            return false;
          }
        });
      }
    });
  };
  function saleBadge() {
    // if(badge === "OUTLET") {
    //   return(
    //     <><div className="product_tags product_tag_final_sale">5 FOR $100</div></>
    //   );
    // }

    // if(badge === "10FOR100") {
    //   return(
    //     <><div className="product_tags product_tag_final_sale">10 FOR $100</div></>
    //   )
    // }

    if (badge === "BOGO") {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "product_tags product_tag_final_sale"
      }, "BUY 1 GET 1 FREE"));
    }
    let price = productObj?.price;
    let compareAt = productObj?.compare_at_price;
    if (price < compareAt) {
      let discount = 1 - price / compareAt;
      switch (true) {
        case discount >= 0.89:
          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
            className: "product_tags product_tag_percent_off"
          }, "90% OFF"));
        case discount >= 0.79:
          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
            className: "product_tags product_tag_percent_off"
          }, "80% OFF"));
        case discount >= 0.69:
          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
            className: "product_tags product_tag_percent_off"
          }, "70% OFF"));
        case discount >= 0.59:
          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
            className: "product_tags product_tag_percent_off"
          }, "60% OFF"));
        case discount >= 0.54:
          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
            className: "product_tags product_tag_percent_off"
          }, "55% OFF"));
        case discount >= 0.49:
          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
            className: "product_tags product_tag_percent_off"
          }, "50% OFF"));
        case discount >= 0.44:
          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
            className: "product_tags product_tag_percent_off"
          }, "45% OFF"));
        case discount >= 0.39:
          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
            className: "product_tags product_tag_percent_off"
          }, "40% OFF"));
        case discount >= 0.34:
          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
            className: "product_tags product_tag_percent_off"
          }, "35% OFF"));
        case discount >= 0.29:
          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
            className: "product_tags product_tag_percent_off"
          }, "30% OFF"));
        default:
          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
            className: "product_tags product_tag_final_sale"
          }, "SALE"));
      }
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  React.useEffect(() => {
    if (window._swat) {
      setSwymLoaded(true);
      getWishlistItems();
      observeWishlist();
    } else {
      observeSwat();
    }
  }, []);
  React.useEffect(() => {
    fetchImagesAndVariants();
    let tags = productObj.tags;
    if (hasNamedTag('promo:SALE')) setBadge("SALE");
    if (tags.find(tag => tag === "OUTLET")) setBadge("OUTLET");
    if (tags.find(tag => tag === "10FOR100")) setBadge("10FOR100");
    if (hasNamedTag("promo:BOGO")) setBadge("BOGO");
    if (hasNamedTag('collection:NEW RELEASES')) setBadge2({
      badge: "default_green",
      text: "NEW"
    });
    if (hasNamedTag("promo:APP EXCLUSIVE")) setBadge2({
      badge: "default_green",
      text: "APP EXCLUSIVE"
    });
    if (hasNamedTag("promo:COMING SOON")) setBadge2({
      badge: "default_green",
      text: "COMING SOON"
    });
    if (hasNamedTag("promo:JUST DROPPED")) setBadge2({
      badge: "default_green",
      text: "JUST DROPPED 🔥"
    });
    if (tags.find(tag => tag === "ALMOST GONE")) setBadge2({
      badge: "almost_gone_badge",
      text: "ALMOST GONE"
    });
    if (tags.find(tag => tag === "SOLD OUT")) setBadge2({
      badge: "sold_out_badge",
      text: "SOLD OUT"
    });
    if (tags.find(tag => tag === "BACK IN STOCK")) setBadge2({
      badge: "back_in_stock_badge",
      text: "BACK IN STOCK"
    });
    if (tags.find(tag => tag === "10FOR100")) setBadge2({
      badge: "almost_gone_badge",
      text: "MIX & MATCH ANY 10/$100 STYLES"
    });
    if (hasNamedTag('promo:FINAL SALE')) setBadge2({
      badge: "almost_gone_badge",
      text: "FINAL SALE"
    });
  }, []);
  React.useEffect(() => {
    //console.log("Product Card props: ",props)
    const instance = inputRef.current;
    if (props.windowWidth > 1100) {
      instance.addEventListener("mouseover", onMouse);
      instance.addEventListener("mouseleave", onMouseLeave);
    }
    if (props.windowWidth < 1100) {
      instance.removeEventListener("mouseover", onMouse);
      instance.removeEventListener("mouseleave", onMouseLeave);
    }
    return () => {
      closeQuickBuy();
      // instance.removeEventListener("click", onClick)
      if (props.windowWidth > 1100) {
        instance.removeEventListener("mouseover", onMouse);
        instance.removeEventListener("mouseleave", onMouseLeave);
      }
    };
  }, [props.windowWidth]);
  async function swatchSelected(handle) {
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({
        query: colorVariantByHandle(handle)
      })
    });
    const shopifyProduct = await response.json();
    setColorVariant(shopifyProduct);
  }
  function hasNamedTag(namedTag) {
    let _name = namedTag.split(':')[0];
    let _tag = namedTag.split(':')[1];
    if (productObj.hasOwnProperty('named_tags')) {
      if (productObj.named_tags_names.find(name => name === _name)) {
        if (productObj.named_tags.hasOwnProperty(_name)) {
          if (Array.isArray(productObj.named_tags[_name])) {
            if (productObj.named_tags[_name].find(tag => tag === _tag)) {
              return true;
            }
          } else if (productObj.named_tags[_name] === _tag) {
            return true;
          }
        }
      }
    } else if (productObj.hasOwnProperty('tags') && productObj.tags.find(tag => tag === namedTag)) {
      return true;
    }
    return false;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "productCard"
  }, /*#__PURE__*/React.createElement("div", {
    className: "imageContainer",
    ref: inputRef
  }, badge2 && /*#__PURE__*/React.createElement("div", {
    className: "rightTag"
  }, /*#__PURE__*/React.createElement("div", {
    className: `default_badge ${badge2.badge}`
  }, /*#__PURE__*/React.createElement("span", null, badge2.text))), timer && /*#__PURE__*/React.createElement("div", {
    className: "rightTag"
  }, /*#__PURE__*/React.createElement(CardTimer, {
    time: timer
  })), badge && /*#__PURE__*/React.createElement("div", {
    id: "product-tag-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "animated_firenew_tag_container"
  }, saleBadge())), /*#__PURE__*/React.createElement("div", {
    className: "drawer-back",
    onClick: e => drawerSwitch(e),
    style: {
      visibility: drawerBackVis
    }
  }), hasNamedTag('promo:COMING SOON') || hasNamedTag('promo:BUNDLE') || hasNamedTag('promo:APP EXCLUSIVE') ? null : /*#__PURE__*/React.createElement("div", {
    className: "quick-buy-hover",
    style: {
      height: drawerHeight,
      opacity: 1,
      zIndex: 110
    }
  }, /*#__PURE__*/React.createElement("h1", {
    className: "quickAdd"
  }, "QUICK BUY"), /*#__PURE__*/React.createElement("div", {
    className: "variants"
  }, productVariants && productVariants.map((value, index) => /*#__PURE__*/React.createElement("div", {
    className: `variantButton ${value.node.quantityAvailable > 0 && !hasNamedTag('promo:APP EXCLUSIVE') ? "" : "disabledVariant"}`,
    onClick: e => {
      if (value.node.quantityAvailable > 0 && !hasNamedTag('promo:APP EXCLUSIVE') && !hasNamedTag('promo:COMING SOON')) {
        addToCart(value.node.id.replace("gid://shopify/ProductVariant/", ""));
        setTimeout(drawerSwitch, 1000, e);
      }
    },
    key: index
  }, /*#__PURE__*/React.createElement("h1", null, value.node.selectedOptions[1] && value.node.selectedOptions[1].value))), productVariants.length == 5 || productVariants.length == 2 ? /*#__PURE__*/React.createElement("a", {
    href: "/products/" + productObj.handle,
    className: "variantButton"
  }, /*#__PURE__*/React.createElement("p", null, "View")) : null)), hasNamedTag('promo:COMING SOON') || hasNamedTag('promo:BUNDLE') || hasNamedTag('promo:APP EXCLUSIVE') ? null : /*#__PURE__*/React.createElement("div", {
    className: "quick-buy-button"
  }, /*#__PURE__*/React.createElement("div", {
    onClick: e => drawerSwitch(e)
  }, /*#__PURE__*/React.createElement("img", {
    alt: "Quick Add Icon to open drawer with size options",
    className: "quickBuyButtonImage",
    src: "https://cdn.shopify.com/s/files/1/2665/0346/files/quick-add-icon.png?v=1680547378"
  }))), /*#__PURE__*/React.createElement("a", {
    href: "/products/" + productObj.handle,
    onClick: sendAlgoliaEvent
  }, loaded ? /*#__PURE__*/React.createElement(React.Fragment, null, productImages && /*#__PURE__*/React.createElement(ProductMedia, {
    productImages: productImages,
    productObj: productObj,
    opacity: opacity,
    windowWidth: props.windowWidth,
    drawerHeight: drawerHeight
  })) : /*#__PURE__*/React.createElement("div", {
    className: "placeholder",
    style: {
      backgroundImage: `url("https://cdn.shopify.com/s/files/1/2665/0346/files/TLF-LOGO-MAIN-WHITE-140px.png?v=1688754720")`
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "productDetailsContainer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "productDetailsWrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: "productDetailsWrapItem"
  }, props.recommended ? /*#__PURE__*/React.createElement("h2", {
    className: "productTitle"
  }, productObj.title) : /*#__PURE__*/React.createElement("h2", {
    className: "productTitle"
  }, /*#__PURE__*/React.createElement(Highlight, {
    attribute: "title",
    hit: props.hit
  }))), !hasNamedTag('promo:BUNDLE') && swymLoaded && /*#__PURE__*/React.createElement("div", {
    onClick: () => {
      addToWishList(productObj.id);
    },
    className: `productDetailsWrapItem productWishlistContainer`
  }, /*#__PURE__*/React.createElement("div", {
    className: `productCardWishlist ${isWishlistItem ? `swym-added` : ``}`,
    "data-product-id": `${productObj.id}`
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1,
    stroke: "currentColor",
    className: ""
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z"
  }))))), productObj.compare_at_price != productObj.price || productObj?.variants?.edges[0]?.node?.compareAtPrice?.amount != productObj?.variants?.edges[0]?.node?.price?.amount ? /*#__PURE__*/React.createElement("div", {
    className: "productPrice",
    style: {
      color: "#B30000",
      fontSize: "15px"
    }
  }, "$", parseFloat(productObj.price ? productObj?.price : productObj?.variants?.edges[0]?.node?.price?.amount).toFixed(2), " ", /*#__PURE__*/React.createElement("span", {
    className: "lineThrough"
  }, "$", parseFloat(productObj.compare_at_price ? productObj?.compare_at_price : productObj?.variants?.edges[0]?.node?.compareAtPrice?.amount).toFixed(2))) : /*#__PURE__*/React.createElement("div", {
    className: "productPrice"
  }, " $", parseFloat(productObj.price ? productObj?.price : productObj?.variants?.edges[0]?.node.price?.amount).toFixed(2)))));
}
function ProductMedia(props) {
  const {
    productImages,
    productObj,
    opacity,
    windowWidth,
    drawerHeight
  } = props;
  const [hasVideo, setHasVideo] = React.useState(false);
  const videoRef = React.useRef();
  React.useEffect(() => {
    if (productImages[2] !== undefined) {
      if (productImages[2]?.node?.altText && productImages[2]?.node?.altText.includes('vimeo') || productImages[2]?.node?.altText && productImages[2]?.node?.altText.includes('mp4')) {
        setHasVideo(true);
      } else {
        setHasVideo(false);
      }
    } else {
      setHasVideo(false);
    }
  }, [productImages]);
  React.useEffect(() => {
    if (videoRef) {
      if (opacity) {
        videoRef?.current?.play();
      } else {
        videoRef?.current?.pause();
      }
    }
  }, [opacity, videoRef]);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React.createElement("img", {
    className: "productCardImage FadeIn",
    alt: `Model wearing ${productObj.title}`,
    src: productImages[0] && productImages[0].node.transformedSrc
  }), hasVideo ? /*#__PURE__*/React.createElement(React.Fragment, null, opacity ? /*#__PURE__*/React.createElement("video", {
    className: "productCardSecondImage",
    ref: videoRef,
    style: {
      opacity: opacity
    },
    src: productImages[2].node.altText,
    muted: true,
    loop: true,
    playsInline: true
  }) : /*#__PURE__*/React.createElement(React.Fragment, null)) : /*#__PURE__*/React.createElement(React.Fragment, null, opacity ? /*#__PURE__*/React.createElement("div", {
    className: "productCardSecondImage",
    style: {
      backgroundImage: `url(${windowWidth && drawerHeight != "0" > 700 ? productImages[1] && productImages[1].node.transformedSrc : ""})`,
      opacity: opacity
    }
  }) : /*#__PURE__*/React.createElement(React.Fragment, null)));
}
function Swatches(props) {
  const [selected, setSelected] = React.useState(null);
  React.useEffect(() => {
    if (selected === null && props.swatches[0]) {
      setSelected(props?.swatches[0]);
    }
  }, [props?.swatches]);
  return /*#__PURE__*/React.createElement("div", {
    className: "swatchContainer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "swatchWrap"
  }, props.product && props.swatches.map((handle, index) => {
    if (index < 5) {
      return /*#__PURE__*/React.createElement("div", {
        key: index,
        className: `swatch ${handle === selected ? `selectedSwatch` : ``}`
      }, /*#__PURE__*/React.createElement("img", {
        className: "productDetailSwatch",
        src: `https://cdn.shopify.com/s/files/1/2665/0346/files/${handle}.jpg`,
        onError: e => {
          e.target.style.display = "none";
          e.target.parentNode.style.display = "none";
        },
        onClick: () => {
          props.callBack(handle);
          setSelected(handle);
        }
      }));
    } else if (index == 5) {
      return /*#__PURE__*/React.createElement("a", {
        key: index,
        href: `/products/${props.product.handle}`
      }, /*#__PURE__*/React.createElement("div", {
        className: "swatchMore"
      }, "+", props.swatches.length - 5));
    } else {
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: index
      });
    }
  })));
}
function CardTimer(props) {
  const start = new Date(JSON.parse(props.time)[0]).toLocaleString("en-US", {
    timeZone: "America/New_York"
  });
  const deadline = new Date(JSON.parse(props.time)[1]).toLocaleString("en-US", {
    timeZone: "America/New_York"
  });
  const time = Date.parse(deadline) - Date.parse(new Date().toLocaleString("en-US", {
    timeZone: "America/New_York"
  }));
  const [hours, setHours] = React.useState(0);
  const [minutes, setMinutes] = React.useState(0);
  const [seconds, setSeconds] = React.useState(0);
  const [visible, setVesible] = React.useState("visible");
  const [live, setLive] = React.useState(false);
  const getTime = () => {
    setLive(Date.parse(new Date().toLocaleString("en-US", {
      timeZone: "America/New_York"
    })) - Date.parse(start) > 0);
    setHours(Math.floor(time / (1000 * 60 * 60)));
    setMinutes(Math.floor(time / 1000 / 60 % 60));
    setSeconds(Math.floor(time / 1000 % 60));
    // setLoaded(true)
    visible === "visible" ? setVesible("hidden") : setVesible("visible");
  };
  React.useEffect(() => {
    const interval = setInterval(() => getTime(), 1000);
    return () => clearInterval(interval);
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "default_badge",
    style: {
      color: "white",
      background: "#171717"
    }
  }, hours < 0 && minutes < 0 && seconds < 0 ? /*#__PURE__*/React.createElement(React.Fragment, null) : live && /*#__PURE__*/React.createElement("div", {
    className: "",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, "OFFER ENDS IN", /*#__PURE__*/React.createElement("div", {
    style: {
      marginLeft: "10px",
      width: "22px"
    }
  }, hours < 10 ? "0" + hours : hours), /*#__PURE__*/React.createElement("span", {
    style: {
      visibility: visible
    },
    className: ""
  }, ":"), /*#__PURE__*/React.createElement("div", {
    style: {
      width: "22px"
    }
  }, minutes < 10 ? "0" + minutes : minutes), /*#__PURE__*/React.createElement("span", {
    style: {
      visibility: visible
    },
    className: ""
  }, ":"), /*#__PURE__*/React.createElement("div", {
    style: {
      width: "22px"
    }
  }, seconds < 10 ? "0" + seconds : seconds)));
}
